// extracted by mini-css-extract-plugin
export var container = "_cl-0";
export var popoverContent = "_cl-1";
export var tosLink = "_cl-2";